import React from 'react';

class Information extends React.Component {
    render() {
        return <div className="information">Gjeldsopplysningene er levert av Gjeldsregisteret AS. Se <a href="https://www.gjeldsregisteret.com/pages/oversikt-over-finansforetak-som-leverer-informasjon" target="_blank" rel="noopener noreferrer" alt="Gjeldsregisteret AS hjemmeside">gjeldsregisteret.com</a> for nærmere informasjon og oversikt over
            finansforetak/kredittyter som leverer gjeldsopplysninger til Gjeldsregisteret. Gjeldsregisteret gir kun informasjon om usikret gjeld. Bruk av denne innsynstjenesten som del av andre tjenester krever avtale med Gjeldsregisteret AS.</div>;
    }
}

export default Information;